<section class="vc-admin-password-rules" aria-live="polite">
  <h4>{{ 'ADMIN.FORMS.PASSWORD_RULES.TITLE' | translate }}</h4>

  <ul>
    <li [class.valid]="hasLength">
      <i class="fas" [class.fa-check-circle]="hasLength" [class.fa-circle]="!hasLength"></i>
      <span>{{ 'ADMIN.FORMS.PASSWORD_RULES.LENGTH' | translate }}</span>
    </li>
    <li [class.valid]="hasUppercase">
      <i class="fas" [class.fa-check-circle]="hasUppercase" [class.fa-circle]="!hasUppercase"></i>
      <span>{{ 'ADMIN.FORMS.PASSWORD_RULES.UPPERCASE' | translate }}</span>
    </li>
    <li [class.valid]="hasLowercase">
      <i class="fas" [class.fa-check-circle]="hasLowercase" [class.fa-circle]="!hasLowercase"></i>
      <span>{{ 'ADMIN.FORMS.PASSWORD_RULES.LOWERCASE' | translate }}</span>
    </li>
    <li [class.valid]="hasNumber">
      <i class="fas" [class.fa-check-circle]="hasNumber" [class.fa-circle]="!hasNumber"></i>
      <span>{{ 'ADMIN.FORMS.PASSWORD_RULES.NUMBER' | translate }}</span>
    </li>
    <li [class.valid]="hasSymbol">
      <i class="fas" [class.fa-check-circle]="hasSymbol" [class.fa-circle]="!hasSymbol"></i>
      <span>{{ 'ADMIN.FORMS.PASSWORD_RULES.SYMBOL' | translate }}</span>
    </li>
    <li [class.valid]="hasNoSpaces">
      <i class="fas" [class.fa-check-circle]="hasNoSpaces" [class.fa-circle]="!hasNoSpaces"></i>
      <span>{{ 'ADMIN.FORMS.PASSWORD_RULES.NO_SPACES' | translate }}</span>
    </li>
  </ul>
</section>
